import * as React from 'react'
import { connect } from 'react-redux'
import { ControlGroup, InputGroup, Button } from '@blueprintjs/core'
import * as Sentry from '@sentry/browser'
import client from '../../../client'
import { showSuccess, showFailure } from '../../../Toast'
import { AppState } from '../../../store'
import { CurrentState } from '../../../current/types'
import { getErrorString } from '../../../utils/serverErrorUtils'

export interface StoreAdminEditProps {
  current: CurrentState
}

export interface StoreAdminEditState {
  email: string
}

const style = {
  emailInput: { width: 250 }
}

class StoreAdminEdit extends React.Component<StoreAdminEditProps, StoreAdminEditState> {
  constructor(props) {
    super(props)
    this.state = {
      email: props.current.user.email || ''
    }
  }

  onSubmit = async () => {
    const { email } = this.state
    const user = {
      email
    }
    try {
      const res = await client.updateUserV5({ user })
      this.setState(
        {
          email: res.data.email
        },
        () => {
          showSuccess('Email updated! This page will now reload.')
          setTimeout(() => window.location.reload(), 750)
        }
      )
    } catch (error) {
      const message = getErrorString(error, Sentry.captureException) || 'Please check the format and try again'
      showFailure(`Failed to update email. ${message}`)
    }
  }

  render() {
    const { email } = this.state
    return (
      <div>
        <ControlGroup>
          <InputGroup
            autoComplete="off"
            style={style.emailInput}
            value={email}
            onChange={e => this.setState({ email: e.target.value })}
            placeholder="you@example.com"
          />
          <Button intent="primary" type="submit" onClick={this.onSubmit}>
            Save
          </Button>
        </ControlGroup>
      </div>
    )
  }
}

export default connect((state: AppState) => ({ current: state.current }))(StoreAdminEdit)
